import type {Surface} from '../shared/types';
import {surfaceRegions} from '../shared/surfaceRegions';
import {compileSurfaceMask} from '../shared/surfaceGeometry';
import {isPaintableSurface} from '../shared/surfaceRoles';

/** Uses the same normalized physical geometry as SVG/hit/fill/accounting.
 * Coordinates are relative to the caller's current transform. */
export function clipSurfaceCanvas(context:CanvasRenderingContext2D,surface:Surface,width=surface.width,height=surface.height):void {
  const sx=width/surface.width,sy=height/surface.height;
  context.beginPath();
  if(isPaintableSurface(surface)){
    if(surface.contours||surface.reservePanels)for(const polygon of compileSurfaceMask(surface).polygons)for(const ring of polygon){
      context.moveTo(ring[0][0]*sx,ring[0][1]*sy);
      for(const [x,y] of ring.slice(1,-1))context.lineTo(x*sx,y*sy);
      context.closePath();
    }
    else for(const region of surfaceRegions(surface))context.rect(region.x*sx,region.y*sy,region.width*sx,region.height*sy);
  }
  context.clip();
}
